var render = function render(_c,_vm){return _c('li',{staticClass:"C-dropdown-menu__item",class:[_vm.data.staticClass, _vm.data.class]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }